// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"609":"237cfbdf","711":"a1ff2a3e","787":"26a7872e"}[chunkId] + ".chunk.js";
};